/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { Loading } from '../loading/index.js';
import props from './props.js';
import { renderTNodeJSX } from '../utils/render-tnode.js';
import { LOADING, LOAD_MORE } from './const.js';
import { getClassPrefixMixins } from '../config-provider/config-receiver.js';
import mixins from '../utils/mixins.js';
import '../loading/directive.js';
import 'lodash/isObject';
import 'lodash/mapKeys';
import 'lodash/isEqual';
import '../loading/plugin.js';
import 'vue';
import '../loading/loading.js';
import '../loading/icon/gradient.js';
import '../_common/js/loading/circle-adapter.js';
import '../_common/js/utils/set-style.js';
import '../_common/js/utils/helper.js';
import '@babel/runtime/helpers/toConsumableArray';
import '@babel/runtime/helpers/objectWithoutProperties';
import '@babel/runtime/helpers/slicedToArray';
import 'lodash/isString';
import 'lodash/isNull';
import 'lodash/isUndefined';
import 'lodash/isNumber';
import 'lodash/isArray';
import '../utils/dom.js';
import 'raf';
import '../utils/easing.js';
import '../utils/transfer-dom.js';
import '../loading/props.js';
import '../config.js';
import 'lodash/mergeWith';
import '../config-provider/context.js';
import 'lodash/merge';
import '../_common/js/global-config/default-config.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '@babel/runtime/helpers/typeof';
import '../_chunks/dep-fdafdce0.js';
import 'dayjs';
import '../_chunks/dep-9849f16c.js';
import '../config-provider/type.js';
import '@vue/composition-api';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import '../utils/withInstall.js';
import 'lodash/capitalize';
import './style/css.js';
import '../loading/type.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var classPrefixMixins = getClassPrefixMixins("list");
var _List = mixins(classPrefixMixins).extend({
  name: "TList",
  props: _objectSpread({}, props),
  computed: {
    listClass: function listClass() {
      var _ref;
      return ["".concat(this.componentName), this.commonSizeClassName[this.size], (_ref = {}, _defineProperty(_ref, "".concat(this.componentName, "--split"), this.split), _defineProperty(_ref, "".concat(this.componentName, "--stripe"), this.stripe), _defineProperty(_ref, "".concat(this.componentName, "--vertical-action"), this.layout === "vertical"), _ref)];
    },
    loadingClass: function loadingClass() {
      if (this.asyncLoading === "loading") return this.commonStatusClassName.loading;
      if (this.asyncLoading === "load-more") return this.commonStatusClassName.loadMore;
      return "";
    }
  },
  components: {
    Loading: Loading
  },
  methods: {
    renderLoading: function renderLoading() {
      var h = this.$createElement;
      if (this.asyncLoading && typeof this.asyncLoading === "string") {
        var _LOADING$LOAD_MORE$th;
        var text = (_LOADING$LOAD_MORE$th = {}, _defineProperty(_LOADING$LOAD_MORE$th, LOADING, "\u6B63\u5728\u52A0\u8F7D\u4E2D\uFF0C\u8BF7\u7A0D\u540E"), _defineProperty(_LOADING$LOAD_MORE$th, LOAD_MORE, "\u70B9\u51FB\u52A0\u8F7D\u66F4\u591A"), _LOADING$LOAD_MORE$th)[this.asyncLoading];
        var loading = this.asyncLoading === LOADING;
        return h(Loading, {
          "class": this.loadingClass,
          "attrs": {
            "loading": loading,
            "text": text
          }
        });
      }
      return renderTNodeJSX(this, "asyncLoading");
    },
    handleScroll: function handleScroll(e) {
      var listElement = this.$el;
      var scrollTop = listElement.scrollTop,
        scrollHeight = listElement.scrollHeight,
        clientHeight = listElement.clientHeight;
      this.$emit("scroll", {
        $event: e,
        scrollTop: scrollTop,
        scrollBottom: scrollHeight - clientHeight - scrollTop
      });
      if (this.onScroll) {
        this.onScroll({
          e: e,
          scrollTop: scrollTop,
          scrollBottom: scrollHeight - clientHeight - scrollTop
        });
      }
    },
    handleLoadMore: function handleLoadMore(e) {
      if (typeof this.asyncLoading === "string" && this.asyncLoading !== LOAD_MORE) return;
      this.$emit("load-more", {
        e: e
      });
      if (this.onLoadMore) {
        this.onLoadMore({
          e: e
        });
      }
    },
    renderContent: function renderContent() {
      var h = this.$createElement;
      var propsHeaderContent = renderTNodeJSX(this, "header");
      var propsFooterContent = renderTNodeJSX(this, "footer");
      return [propsHeaderContent && h("div", {
        "class": "".concat(this.componentName, "__header")
      }, [propsHeaderContent]), h("ul", {
        "class": "".concat(this.componentName, "__inner")
      }, [renderTNodeJSX(this, "default")]), propsFooterContent && h("div", {
        "class": "".concat(this.componentName, "__footer")
      }, [propsFooterContent])];
    }
  },
  render: function render() {
    var h = arguments[0];
    var listContent = this.renderContent();
    listContent = [listContent, h("div", {
      "class": "".concat(this.componentName, "__load"),
      "on": {
        "click": this.handleLoadMore
      }
    }, [this.renderLoading()])];
    return h("div", {
      "class": this.listClass,
      "on": {
        "scroll": this.handleScroll
      }
    }, [listContent]);
  }
});

export { _List as default };
//# sourceMappingURL=list.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/list/list.js
// module id = null
// module chunks = 